import { Loc } from 'main.core';

export const reminderValues = [
	{
		value: 0,
		label: Loc.getMessage('BOOKING_REMINDER_0'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_0'),
	},
	{
		value: 5,
		label: Loc.getMessage('BOOKING_REMINDER_5'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_5'),
	},
	{
		value: 10,
		label: Loc.getMessage('BOOKING_REMINDER_10'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_10'),
	},
	{
		value: 15,
		label: Loc.getMessage('BOOKING_REMINDER_15'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_15'),
	},
	{
		value: 20,
		label: Loc.getMessage('BOOKING_REMINDER_20'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_20'),
	},
	{
		value: 30,
		label: Loc.getMessage('BOOKING_REMINDER_30'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_30'),
	},
	{
		value: 60,
		label: Loc.getMessage('BOOKING_REMINDER_60'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_60'),
	},
	{
		value: 120,
		label: Loc.getMessage('BOOKING_REMINDER_120'),
		shortLabel: Loc.getMessage('BOOKING_REMINDER_SHORT_120'),
	},
];
